import secureLocalStorage from "react-secure-storage";
import { useAuth } from "../../../context/auth";
import { useEffect, useMemo, useState } from "react";
import {
  DeleteFeriado,
  GetDataFeriado,
  PostFeriado,
} from "../../../data/services";
import ConfirmDeleteModal from "../components/ConfirmDeleteModal";
import { toast } from "react-toastify";
import AdicionarFeriados from "./AdicionarFeriados";

const AdminFeriados = () => {
  const { user } = useAuth();
  const profile = user.profile;

  if (profile === "usuarioFornecedor") window.location.href = "/home";
  const token: any = secureLocalStorage.getItem("access_token");
  if (!token) {
    window.location.href = "/";
  }
  const UnidadeAdmin = "adminUnidade";
  const SuperAdmin = "superAdmin";
  const adm = profile === SuperAdmin || profile === UnidadeAdmin;

  const [feriadosOptions, setFeriadosOptions] = useState<any>([]);
  const [selectedFeriado, setSelectedFeriado] = useState<any>(null);
  const [openAdicionar, setOpenAdicionar] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    GetDataFeriado(setFeriadosOptions);
  }, []);

  // Salvar e atualizar lista
  async function handleSaveFeriado(feriado: {
    dia: string;
    mes: string;
    descricaoFeriado: string;
  }) {
    try {
      await PostFeriado(feriado);
      GetDataFeriado(setFeriadosOptions);
      setOpenAdicionar(false);
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  const handleConfirmDelete = async () => {
    try {
      await DeleteFeriado(selectedFeriado.idFeriado);
      toast.success("Feriado deletado com sucesso!");
      setFeriadosOptions((prev: any[]) =>
        prev.filter((item) => item.idFeriado !== selectedFeriado.idFeriado)
      );
    } catch (error) {
      toast.error("Erro ao deletar feriado.");
    } finally {
      toggleModal();
    }
  };

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const ListColumns = useMemo(() => {
    return (
      <>
        <td className="listProperty">Data do feriado</td>
        <td className="listProperty">Descrição</td>
        {adm && <td className="listProperty">Ações</td>}
      </>
    );
  }, []);

  const List = useMemo(() => {
    return (
      <>
        {feriadosOptions
          .sort(function (a: any, b: any) {
            if (a.mes > b.mes) {
              return 1;
            }
            if (a.mes < b.mes) {
              return -1;
            }

            if (a.dia > b.dia) {
              return 1;
            }
            if (a.dia < b.dia) {
              return -1;
            }
            return 0;
          })
          .map((item: any) => {
            return (
              <>
                <div
                  className="row"
                  style={{
                    textAlign: "center",
                  }}
                >
                  <table className="table">
                    <tbody>
                      <tr>
                        <td className="col-md-3">
                          {`${item.dia < 10 ? "0" + item.dia : item.dia}/${
                            item.mes < 10 ? "0" + item.mes : item.mes
                          }`}
                        </td>
                        <td className="col-md-6">{item.descricaoFeriado}</td>
                        <td className="col-md-2">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-start",
                              columnGap: "5px",
                            }}
                          >
                            {/* <button
                              // className="editBtn"
                              className="btn btn-light"
                              //   onClick={() => {
                              //     setOpen((prev: any) => ({
                              //       ...prev,
                              //       open: true,
                              //       method: "putch",
                              //     }));
                              //     setInfo(item);
                              //   }}
                              style={{ float: "left", margin: "2" }}
                            >
                              Editar
                            </button> */}
                            <button
                              // className="deleteUserBtn"
                              className="btn btn-danger"
                              onClick={() => {
                                setSelectedFeriado(item);
                                setIsModalOpen(true);
                              }}
                              style={{ float: "right" }}
                            >
                              Deletar
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </>
            );
          })}
      </>
    );
  }, [feriadosOptions]);

  return (
    <div className="modalSignUp">
      <div className="content-header-button-and-title">
        <h1>Feriado</h1>

        {adm && (
          <button className="BtnClean" onClick={() => setOpenAdicionar(true)}>
            Adicionar
          </button>
        )}
      </div>

      <div className="contentList">{ListColumns}</div>
      <div className="content">
        <div className="containerListInfo">
          {feriadosOptions.length > 0 ? (
            <>{List}</>
          ) : (
            <div style={{ textAlign: "center" }}>
              <h1 style={{ margin: "35px 0", fontSize: 28 }}>
                Não há registros aqui
              </h1>
            </div>
          )}
        </div>
      </div>

      {openAdicionar && (
        <AdicionarFeriados
          onSave={handleSaveFeriado}
          onCancel={() => setOpenAdicionar(false)}
        />
      )}

      <ConfirmDeleteModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        onConfirm={handleConfirmDelete}
        itemName={selectedFeriado?.descricaoFeriado ?? ""}
      />
    </div>
  );
};

export default AdminFeriados;
